import React from 'react';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import { Login } from './Login';
import { VerifyCode } from './VerifyCode';
import { CaseRequests } from './CaseRequests';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './material-theme';
import './App.css';
import { IFIAppBar } from './IFIAppBar';
import { StudentDetails } from './StudentDetails';
import { Settings } from './Settings';
import { AuthContextProvider } from './AuthContextProvider';
import { WelcomeStudent } from './welcome-student';

const App = () => (
  <div className="App" style={{ padding: '2em' }}>
    <ThemeProvider theme={theme}>
      <Router>
        <AuthContextProvider>
          <IFIAppBar />
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/verify" component={VerifyCode} />
            <Route exact path="/requests" component={CaseRequests} />
            <Route
              exact
              path="/events"
              component={(props) => (
                <CaseRequests {...props} requestType="Event" />
              )}
            />
            <Route exact path="/studentDetail/:id" component={StudentDetails} />
            <Route exact path="/settings" component={Settings} />
            <Route exact path="/welcome" component={WelcomeStudent} />
            <Redirect to="/requests" />
          </Switch>
        </AuthContextProvider>
      </Router>
    </ThemeProvider>
  </div>
);

export default App;
